import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function FileCountIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        d="M9.75 6.75H6.75C5.64543 6.75 4.75 7.64543 4.75 8.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25H13.25C14.3546 19.25 15.25 18.3546 15.25 17.25V12.25M9.75 6.75L15.25 12.25M9.75 6.75V10.25C9.75 11.3546 10.6454 12.25 11.75 12.25H15.25M11.75 4.75H13.75L19.25 10.25V15.25C19.25 16.3546 18.3546 17.25 17.25 17.25H15.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
